"use strict";

require("bower_components/angular-gettext/dist/angular-gettext.min.js");

angular.module("availabilityStatus", ["gettext"]);

require("./availability-status.filter.js");



//////////////////
// WEBPACK FOOTER
// ./vendor/app-core/availability-status/availability-status.module.js
// module id = 675
// module chunks = 0